module.exports = __webpack_public_path__ + "static/media/19.83c155c9.png";